import type { BannerClickEventDetail } from './trackBannerClick';
import { getActiveAppAnalytics } from './injectAppAnalytics';

export function forwardBannerClickToAnalytics(detail: BannerClickEventDetail): void {
  const analytics = getActiveAppAnalytics();
  if (!analytics) {
    return;
  }

  const payload = {
    analytics_tag: detail.analytics_tag,
    banner_id: detail.banner_id,
    ...(detail.banner_key ? { banner_key: detail.banner_key } : {}),
  };

  if (analytics.provider === 'ga4' || analytics.provider === 'gtm') {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'banner_click', payload);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'banner_click', ...payload });
    return;
  }

  if (analytics.provider === 'clarity' && typeof window.clarity === 'function') {
    window.clarity('event', 'banner_click', detail.analytics_tag, detail.banner_id);
  }
}
